/**
 * Route Constants
 *
 */

export const VAULT_ROUTES = {
  offering: (offeringId: string) => `/vault/offering/${offeringId}`,
  investmentDetails: (investmentId: string) => `/vault/investment/${investmentId}`,
  details: (investmentId: string) => `/vault/investment/${investmentId}/details`,
  payment: (investmentId: string) => `/vault/investment/${investmentId}/payment`,
  payments: (investmentId: string) => `/vault/investment/${investmentId}/payments`,
  printPayments: (investmentId: string, paymentType: string) =>
    `/vault/investment/${investmentId}/payments/print?type=${paymentType}`,
  inquiry: (investmentId: string) => `/vault/investment/${investmentId}/identity-check`,
  inquiryKYCList: (investmentId: string, userId: string) =>
    `/vault/investment/${investmentId}/identity-check/kyc/${userId}`,
  inquiryKYBList: (investmentId: string, userId: string) =>
    `/vault/investment/${investmentId}/identity-check/kyb/${userId}`,
  inquiryDetails: (investmentId: string, inquiryId: string) =>
    `/vault/investment/${investmentId}/identity-check/details/${inquiryId}`,
  accreditation: (investmentId: string) => `/vault/investment/${investmentId}/accreditation`,
  agreements: (investmentId: string) => `/vault/investment/${investmentId}/agreements`,
} as const;
